var React = require('react');

function Telegram (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#29b6f6","d":"M24,4C13,4,4,13,4,24s9,20,20,20s20-9,20-20S35,4,24,4z","key":0}),React.createElement("path",{"fill":"#fff","d":"M34,15l-3.7,19.1c0,0-0.2,0.9-1.2,0.9c-0.6,0-0.9-0.3-0.9-0.3L20,28l-4-2l-5.1-1.4c0,0-0.9-0.3-0.9-1\tc0-0.6,0.9-0.9,0.9-0.9l21.3-8.5c0,0,0.7-0.2,1.1-0.2c0.3,0,0.6,0.1,0.6,0.5C34,14.8,34,15,34,15z","key":1}),React.createElement("path",{"fill":"#b0bec5","d":"M23,30.5l-3.4,3.4c0,0-0.1,0.1-0.3,0.1c-0.1,0-0.1,0-0.2,0l1-6L23,30.5z","key":2}),React.createElement("path",{"fill":"#cfd8dc","d":"M29.9,18.2c-0.2-0.2-0.5-0.3-0.7-0.1L16,26c0,0,2.1,5.9,2.4,6.9c0.3,1,0.6,1,0.6,1l1-6l9.8-9.1\tC30,18.7,30.1,18.4,29.9,18.2z","key":3})]);
}

Telegram.defaultProps = {"viewBox":"0 0 48 48","width":"96px","height":"96px"};

module.exports = Telegram;

Telegram.default = Telegram;
